<div class="container-fluid">
  <div class="d-flex justify-content-between">
    <h3><strong>TBT-TOC Detail for Invoice: {{ invoice }}</strong></h3>
    <div class="d-flex">
      <div>
        <button [disabled]="isDownloading" class="mr-2" mat-flat-button aria-label="Download Excel" (click)="downloadExcel.emit()"
                color="accent">Download Excel
        </button>
        <mat-progress-bar *ngIf="isDownloading" mode="indeterminate" color="accent"></mat-progress-bar>
      </div>
      <button mat-flat-button aria-label="Return To List" (click)="navigateBack()" color="accent">Return To List</button>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-2">
      <div>
        <strong class="mr-3">Month Ended:</strong>
        <b>{{ details?.billDate | date:'MM/dd/yyyy' }}</b>
      </div>
      <div>
        <strong class="mr-3">NS TBT Number:</strong>
        <b>{{ details?.customerNum }}</b>
      </div>
    </div>
    <div class="col-2">
      <div>
        <strong class="mr-2">WayBill Number:</strong>
        <b>{{ details?.waybillNum }}</b>
      </div>
      <div>
        <strong class="mr-5">Bill To:</strong>
        <b>{{ details?.billedTo }}</b>
      </div>
    </div>
    <div class="col-3">
      <div class="d-flex">
        <strong class="mr-3">Address:</strong>
        <b [innerHTML]="details?.customerAddress"></b>
      </div>
    </div>
  </div>
  <div class="row my-3 justify-content-center">
    <div class="col-5">
      <div class="h-auto border-top">
        <div class="d-flex justify-content-between">
          <strong>Total Monthly Charge</strong>
          <strong>{{ details?.totalAmount | currency }}</strong>
        </div>
      </div>
    </div>
  </div>
  <div class="row my-3 justify-content-center">
    <table mat-table [dataSource]="details?.summaryEntry || []" class="w-100 mx-4 mat-elevation-z1">
      <ng-container matColumnDef="freeDays">
        <th mat-header-cell *matHeaderCellDef class="text-center font-weight-bold">Tier</th>
        <td mat-cell *matCellDef="let element" class="text-center font-weight-bold">{{ element.freeDays }}</td>
      </ng-container>
      <ng-container matColumnDef="billableDays">
        <th mat-header-cell *matHeaderCellDef class="text-center font-weight-bold">Chargeable Days</th>
        <td mat-cell *matCellDef="let element" class="text-center font-weight-bold">{{ element.billableDays }}</td>
      </ng-container>
      <ng-container matColumnDef="tierRate">
        <th mat-header-cell *matHeaderCellDef class="text-right font-weight-bold">Rate</th>
        <td mat-cell *matCellDef="let element" class="text-right font-weight-bold">{{ element.tierRate | currency }}</td>
      </ng-container>
      <ng-container matColumnDef="totalBillAmt">
        <th mat-header-cell *matHeaderCellDef class="text-right font-weight-bold">Summary Total</th>
        <td mat-cell *matCellDef="let element" class="text-right font-weight-bold">{{ element.totalBillAmt }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</div>
<div class="h-100">
  <ns-grid [loading]="loading"
           [columns]="columns"
           name="eBill_Tbt_TOC_Details"
           [fileName]="'TBT-TOC Detail for Invoice - ' + invoice || ''"
           (refresh)="reload.emit()"
           [data]="details?.detailEntry || []">
  </ns-grid>
</div>
